import React from 'react'
import {
  Card,
  CardBody,
  CardHeader,
  Collapse,
  FormGroup,
  Input,
  Label
} from 'reactstrap'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import GitOptionCommitSha from './GitOptionCommitSha'
import GitOptionImportBranch from './GitOptionImportBranch'

const GitOptions = ({
  branchChanged = false,
  commitSha = null,
  isOpen,
  onBranchChange,
  onCommitShaChange,
  onUpdateProjectBranchChange = null,
  repositoryId = null,
  selectedBranch = null,
  selectedBranchName = null,
  toggle,
  updateProjectBranch = false
}) => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <Card className={isOpen ? '' : 'border-0'}>
      <CardHeader
        className={`p-2 ${isOpen ? '' : 'border'}`}
        onClick={() => toggle()}
        style={{
          cursor: 'pointer'
        }}
      >
        <div className="text-muted font-weight-bold">
          {t('GitOptions.title')}
        </div>
      </CardHeader>
      <CardBody className={isOpen ? '' : 'p-0'}>
        <Collapse
          className={isOpen ? '' : 'border-0'}
          isOpen={isOpen}
        >
          <GitOptionImportBranch
            onChange={(selected) => onBranchChange(selected)}
            repositoryId={repositoryId}
            selectedBranch={selectedBranch}
            selectedBranchName={selectedBranchName}
          />
          {branchChanged && onUpdateProjectBranchChange && (
            <div className="d-flex flex-row justify-content-between mb-2">
              <div className="d-flex flex-column justify-content-center" />
              <div style={{ width: 300 }} className="d-flex justify-content-start">
                <FormGroup check className="mb-0">
                  <Label check className="d-flex align-items-center mb-0">
                    <Input
                      checked={updateProjectBranch}
                      onChange={({ target: { checked } }) => onUpdateProjectBranchChange(checked)}
                      type="checkbox"
                    />
                    <span className="ms-2">{t('GitOptions.setAsDefaultBranch')}</span>
                  </Label>
                </FormGroup>
              </div>
            </div>
          )}
          <GitOptionCommitSha
            onChange={(selected) => onCommitShaChange(selected)}
            commitSha={commitSha}
          />
        </Collapse>
      </CardBody>
    </Card>
  )
}

GitOptions.propTypes = {
  branchChanged: PropTypes.bool,
  commitSha: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onBranchChange: PropTypes.func.isRequired,
  onCommitShaChange: PropTypes.func.isRequired,
  onUpdateProjectBranchChange: PropTypes.func,
  repositoryId: PropTypes.number,
  selectedBranch: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }),
  selectedBranchName: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  updateProjectBranch: PropTypes.bool
}

const mapStateToProps = ({
  integrations: {
    branchesFetchingError,
    branchesFetchingStatus,
    branches
  }
}) => ({
  branchesFetchingError,
  branchesFetchingStatus,
  branches
})

export default connect(mapStateToProps)(GitOptions)
